export enum ServiceConfigurationScope {
  MobizAdministrator = 'MobizAdministrator',
  Organization = 'Organization',
}
